import { api } from 'redux-store/api';
import {
  ICreateSelectionVariantLibraryArgs,
  ICreateSelectionVariantLibraryResponse,
  ICreateSelectionVariantTypeArgs,
  ICreateSelectionVariantTypeResponse,
  IDeleteSelectionVariantLibraryArgs,
  IDeleteSelectionVariantTypeArgs,
  IGetSelectionVariantLibraryResponse,
  IGetSelectionVariantTypesResponse,
  IUpdateSelectionVariantLibraryArgs,
  IUpdateSelectionVariantLibraryResponse,
  IUpdateSelectionVariantTypeArgs,
  IUpdateSelectionVariantTypeResponse,
} from './selection-variant.types';

export enum Endpoints {
  SELECTION_VARIANT_TYPES = 'selection-variant-type/',
  SELECTION_VARIANT_LIBRARY = 'selection-variant-library/',
}

export const selectionVariantApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSelectionVariantTypes: build.query<IGetSelectionVariantTypesResponse, void>({
      query: () => ({
        url: Endpoints.SELECTION_VARIANT_TYPES,
      }),
      keepUnusedDataFor: 0,
      providesTags: ['Selection Variant Types'],
    }),

    createSelectionVariantType: build.mutation<
      ICreateSelectionVariantTypeResponse,
      ICreateSelectionVariantTypeArgs
    >({
      query: (body) => ({
        url: Endpoints.SELECTION_VARIANT_TYPES,
        method: 'POST',
        body,
      }),
      invalidatesTags: (_, err) => (err ? [] : ['Selection Variant Types']),
    }),

    updateSelectionVariantType: build.mutation<
      IUpdateSelectionVariantTypeResponse,
      IUpdateSelectionVariantTypeArgs
    >({
      query: (body) => ({
        url: `${Endpoints.SELECTION_VARIANT_TYPES}${body.id}`,
        method: 'PATCH',
        body: { name: body.name },
      }),
      invalidatesTags: (_, err) => (err ? [] : ['Selection Variant Types']),
    }),

    deleteSelectionVariantType: build.mutation<void, IDeleteSelectionVariantTypeArgs>({
      query: ({ id }) => ({
        url: `${Endpoints.SELECTION_VARIANT_TYPES}${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_, err) => (err ? [] : ['Selection Variant Types']),
    }),

    getSelectionVariantLibrary: build.query<IGetSelectionVariantLibraryResponse, void>({
      query: () => ({
        url: Endpoints.SELECTION_VARIANT_LIBRARY,
      }),
      keepUnusedDataFor: 0,
      providesTags: ['Selection Variant Library'],
    }),

    createSelectionVariantLibrary: build.mutation<
      ICreateSelectionVariantLibraryResponse,
      ICreateSelectionVariantLibraryArgs
    >({
      query: (body) => ({
        url: Endpoints.SELECTION_VARIANT_LIBRARY,
        method: 'POST',
        body,
      }),
      invalidatesTags: (_, err) => (err ? [] : ['Selection Variant Library']),
    }),

    updateSelectionVariantLibrary: build.mutation<
      IUpdateSelectionVariantLibraryResponse,
      IUpdateSelectionVariantLibraryArgs
    >({
      query: (body) => ({
        url: `${Endpoints.SELECTION_VARIANT_LIBRARY}${body.id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (_, err) => (err ? [] : ['Selection Variant Library']),
    }),

    deleteSelectionVariantLibrary: build.mutation<void, IDeleteSelectionVariantLibraryArgs>({
      query: ({ id }) => ({
        url: `${Endpoints.SELECTION_VARIANT_LIBRARY}${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_, err) => (err ? [] : ['Selection Variant Library']),
    }),
  }),
});

export const {
  useGetSelectionVariantTypesQuery,
  useCreateSelectionVariantTypeMutation,
  useUpdateSelectionVariantTypeMutation,
  useDeleteSelectionVariantTypeMutation,

  useGetSelectionVariantLibraryQuery,
  useCreateSelectionVariantLibraryMutation,
  useUpdateSelectionVariantLibraryMutation,
  useDeleteSelectionVariantLibraryMutation,
} = selectionVariantApi;
